import React, { useCallback } from "react";
import PropTypes from "prop-types";
import classes from "./styles.module.scss";

const GuestsField = ({ value, onChange, isForm }) => {
  const emit = useCallback(
    ({ target: { value: val } }) => {
      onChange(parseInt(val, 10) || 0);
    },
    [onChange]
  );

  return (
    <div className={classes.GuestsFieldContainer}>
      <div className={classes.FieldWrapper}>
        <input
          type="number"
          // placeholder={isForm ? 'Approximately how many people are coming?' : 'Guests'}
          placeholder={"Guests"}
          min="1"
          step="1"
          defaultValue={value || ""}
          onChange={emit}
          required
        />
      </div>
    </div>
  );
};

GuestsField.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  isForm: PropTypes.bool,
};

export default GuestsField;
